import { useEffect } from 'react';

import { useSetAtom } from 'jotai';
import { UseFormReturn, useWatch } from 'react-hook-form';

import { userLocaleAtom } from '@store';

import { UserWelcomeWizardForm } from './useUserWelcomeWizard';

export const useSetLocaleAtom = (form: UseFormReturn<UserWelcomeWizardForm>) => {
    const locale = useWatch({
        control: form.control,
        name: 'locale',
    });

    const set = useSetAtom(userLocaleAtom);

    useEffect(() => {
        set(locale);
    }, [locale]);
};
